import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import dynamic from 'next/dynamic';
import MapMarker from '@/components/maps/map-marker';
import {Loader} from '@googlemaps/js-api-loader';


function MapComponent({centerPosition, markers}: any) {

  const [googleMaps, setGoogleMaps] = useState(true);


  const LeafletMapContainer = dynamic(
    () => import('react-leaflet').then((r: any) => r.MapContainer), {ssr: false}
  );

  const LeafletTileLayer = dynamic(
      () => import('react-leaflet').then((r: any) => r.TileLayer), {ssr: false}
  );

  const LeafletMarker = dynamic(
      () => import('react-leaflet').then((r: any) => r.Marker), {ssr: false}
  );

  const [zoomLevel, setZoomLevel] = useState(12);

  const render = (status: any) => {
    return <h1>{status}</h1>;
  };

  const googlemap = useRef<any>(null);

  useEffect(() => {
    if (googleMaps) {
      const loader = new Loader({
        apiKey: 'AIzaSyAPdNkK2sIUkJs7pUTt2lDQFe4j7PwJoY4',
        version: 'weekly',
      });
      let map; 
      loader.load().then(() => {
        const google = window.google;
        map = new google.maps.Map(googlemap.current, {
          center: {lat: -34.397, lng: 150.644},
          zoom: 8,
        });
      });
    }
  });

  if (googleMaps) {
    return (
      <div id="map" className="map-container" ref={googlemap}>

        <style jsx>{`
          
        `}</style>
      </div>
    );
  }


  //     <LeafletTileLayer
  //     />
      
      
}

export default MapComponent;
